import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getMessaging, isSupported as isMessagingSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID, // Make sure this is set correctly
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);

if (window.location.href.includes("localhost")) {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_DEBUG_DEV_LOCAL;
}
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(process.env.REACT_APP_SITE_KEY),
  isTokenAutoRefreshEnabled: true,
});

// On browsers without the required APIs (iOS Chrome, incognito, some embedded
// webviews) getMessaging() does NOT throw synchronously: it kicks off an
// internal isWindowSupported() check and throws UNSUPPORTED_BROWSER from inside
// that promise. A synchronous try/catch can't catch it, so it surfaced as an
// unhandled rejection (HEXAGONE-FRONT-2). Gate the call behind the SDK's own
// async isSupported() so we never invoke getMessaging on an unsupported
// browser. `messaging` stays null there — FCM callers already handle a missing
// instance. (Live binding: importers see the value once it's set.)
let messaging = null;
isMessagingSupported()
  .then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
    }
  })
  .catch(() => {
    messaging = null;
  });
export { messaging };
// Initialize Firestore and Auth
export const db = getFirestore(app);
//export const dbCentral = getFirestore(appCentral);
export const dbCentral = getFirestore(app);
export const dbHexamails = getFirestore(app, "hexamails");
// export const auth = getAuth(app);
export const auth = getAuth(app);
// export a getAuthCentral function to get the auth instance for the central app
export const getAuthCentral = () => {
  return getAuth(app);
};
export default app;
